<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心-发票管理-发票信息管理
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-invoice-info">
    <div class="filter-container">
      <div class="filter-box">
        <div class="flex" style="font-size: 18px;">
          <f-back />
          <span>{{ $route.meta.title }}</span>
        </div>
      </div>
      <div class="toolbox">
        <el-button v-if="!postFormShow" type="primary" @click="onPostFormClick">修改发票信息</el-button>
      </div>
    </div>

    <el-alert
      v-if="!loading && Object.keys(invoice).length === 0"
      type="warning"
      style="margin-bottom: 15px;"
      title="您还没有填写发票信息，请及时完善，以便发票正常开具。" />

    <el-card v-loading="loading" :body-style="{ margin: '100px' }" shadow="never">
      <el-form
        v-show="!postFormShow"
        ref="displayForm"
        class="display-form"
        label-position="left"
        label-width="120px"
        :model="invoice">
        <el-form-item label="发票类型">
          <span>{{ invoiceTypeObj[invoice.invoice_type] }}</span>
        </el-form-item>
        <el-form-item label="发票抬头">
          <span>{{ invoice.corporate_name }}</span>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <span>{{ invoice.corporate_code }}</span>
        </el-form-item>
        <el-form-item label="地址、电话">
          <span>{{ invoice.detail_address }}</span>
          <span class="span">{{ invoice.telephone }}</span>
        </el-form-item>
        <el-form-item label="开户行及账号">
          <span>{{ invoice.bank }}</span>
          <span class="span">{{ invoice.bank_account }}</span>
        </el-form-item>
      </el-form>
      <el-form
        v-show="postFormShow"
        ref="postForm"
        label-position="left"
        label-width="120px"
        :model="formData"
        :rules="formRules">
        <el-form-item label="发票类型" prop="invoice_type">
          <el-radio-group v-model="formData.invoice_type">
            <el-radio :label="5">增值税电子专用发票</el-radio>
            <el-radio :label="4">增值税电子普通发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头" prop="corporate_name">
          <el-col :span="17">
            <el-input v-model="formData.corporate_name" placeholder="名称" />
          </el-col>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="corporate_code">
          <el-col :span="17">
            <el-input v-model="formData.corporate_code" placeholder="税号" />
          </el-col>
        </el-form-item>
        <el-form-item label="地址、电话">
          <el-col :span="10">
            <el-input v-model="formData.detail_address" placeholder="地址" />
          </el-col>
          <el-col :span="6" :offset="1">
            <el-input v-model="formData.telephone" placeholder="电话" />
          </el-col>
        </el-form-item>
        <el-form-item label="开户行及账号">
          <el-col :span="10">
            <el-input v-model="formData.bank" placeholder="开户行" />
          </el-col>
          <el-col :span="6" :offset="1">
            <el-input v-model="formData.bank_account" placeholder="账号" />
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="postLoading" @click="onPostFormSubmit">提 交</el-button>
          <el-button @click="postFormShow = false">返 回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getInvoiceDetailApi, postInvoiceDetailApi } from '@/api/expense/expenseInvoiceApi'
export default {
  name: 'ExpenseInvoiceDetail',
  components: {
  },
  data() {
    return {
      loading: false,
      postLoading: false,
      postFormShow: false,
      invoice: {},
      formData: {},
      formRules: {
        invoice_type: [
          { required: true, message: '发票类型不能为空', trigger: 'blur' }
        ],
        'corporate_name': [
          { required: true, message: '发票抬头不能为空', trigger: 'blur' }
        ],
        corporate_code: [
          { required: true, message: '纳税人识别号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'invoiceTypeObj'
    ])
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getInvoiceDetailApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.invoice = Object.assign({}, res.data)
        }
      })
    },
    onPostFormClick() {
      this.postFormShow = true
      this.formData = Object.assign({ invoice_type: 2 }, this.invoice)
      this.$nextTick(() => {
        this.$refs['postForm'].clearValidate()
      })
    },
    onPostFormSubmit() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          this.postLoading = true
          postInvoiceDetailApi(this.formData).then(res => {
            this.postLoading = false
            if (!res.errno) {
              // 操作成功处理
              this.fetchData()
              this.postFormShow = false
              this.$message.success('操作成功！')
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.expense-invoice-info {
  width: 1200px;
  margin: 0 auto;
}
</style>
